module.exports = __webpack_public_path__ + "img/news9.9581566d.png";